export const getUsPercentageFormat = (value, maximumSignificantDigits = 3) => {
  return new Intl.NumberFormat('en-US', { maximumSignificantDigits: maximumSignificantDigits }).format(value);
};

export const getUsCurrencyFormat = (value,) => {
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value)
};

export const getUsCurrencyFormatWithoutDecimal = (value,) => {
  return new Intl.NumberFormat('en-US',).format(value)
};

export function formatCurrency(amount) {
  return new Intl.NumberFormat('en-us', {
    style: 'currency',
    currency: 'USD',
  }).format(Number.isNaN(amount) ? 0 : Number(amount));
}

export const getBalanceDisplay = (balance) => {
  return balance
    ? `${Number(balance)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
    : '';
};